import {Container} from 'src/design/atoms/Container';
import {Loader} from 'src/design/atoms/Loader';
import {Stack} from 'src/design/atoms/Stack';
import {Text} from 'src/design/atoms/Text';
import {Title} from 'src/design/atoms/Title';
import {useEffect} from 'react';
import {PathUtility} from 'src/shared/constants/PathBuilder';

import {clearLoginRouting} from 'src/app/security/authentication/configureAmplify';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {useAppDispatch} from 'src/redux/hooks';
import {resetAuthState, signOutUser} from 'src/redux/slices/authSlice';
import {resetSessionState} from 'src/redux/slices/sessionSlice';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import classes from './ResetCache.module.css';
import {useAppNavigate} from 'src/shared/hooks/useAppNavigate';

const ResetCachePage = () => {
  const navigate = useAppNavigate();
  const dispatch = useAppDispatch();
  useSetDocumentTitle('Resetting cache...');

  useEffect(() => {
    // Reset Cookies
    const cookies = document.cookie.split('; ');
    for (let c = 0; c < cookies.length; c++) {
      const d = window.location.hostname.split('.');
      while (d.length > 0) {
        const cookieBase =
          encodeURIComponent(cookies[c].split(';')[0].split('=')[0]) +
          '=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=' +
          d.join('.') +
          ' ;path=';
        const p = location.pathname.split('/');
        document.cookie = cookieBase + '/';
        while (p.length > 0) {
          document.cookie = cookieBase + p.join('/');
          p.pop();
        }
        d.shift();
      }
    }

    // Reset Local storage
    sessionStorage.clear();
    localStorage.clear();

    dispatch(resetSessionState());
    dispatch(resetAuthState());
    void dispatch(signOutUser());
    clearLoginRouting();

    const timer = setTimeout(() => {
      try {
        navigate(PathUtility.Login(), {replace: true});
      } catch (error) {
        console.error(error);
      }
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Container size={420} my={40}>
      <Stack>
        <Title ta="center" className={classes.title}>
          Resetting cache
        </Title>
        <Text c="dimmed" size="sm" ta="center">
          You will be automatically logged out after the reset is complete.
        </Text>
        <Loader size="lg" />
      </Stack>
    </Container>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'transient',
  path: PathUtility.ResetCache(),
  element: <ResetCachePage />,
  isPrivate: false,
});

export {ResetCachePage};
